import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  // using sudo
  getAuthHeaders() {
    return {
      // headers: { Authorization: "Basic c3Vkb0Bmb3hjb25uLmNvbTpzdWRv" },
      headers: {
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzeXN0ZW1Sb2xlIjoic3VkbyIsImVtdWxhdG9yIjp0cnVlLCJzb3VyY2VFbWFpbCI6InN1ZG9AZm94Y29ubi5jb20iLCJzb3VyY2VOYW1lIjoic3VkbyIsImVtYWlsIjoibHVmZkBob3RtYWlsLmNvbSIsIm5hbWUiOiLpra_lpKsiLCJjbGluaWNSb2xlcyI6W3siY2xpbmljIjoiMTY1MDg2NTU3MSIsImNsaW5pY05hbWUiOiLojYnluL3mtbfos4rlnJgiLCJzdGFmZklEIjoiL3N0YWZmL2x1ZmZAaG90bWFpbC5jb20iLCJyb2xlSUQiOiJhZG1pbiIsInJvbGVOYW1lIjoi6Zmi6ZW3IiwicGVybWlzc2lvbnMiOltdfV0sImFsbGlhbmNlIjoiIiwiaWF0IjoxNjg5MzI3ODk1fQ.qm2ZaR9ggmGfiYIWbkrOdyZX2di37yPLP9PqX-aHY3E",
      },
    };
  }

  getPetFilesById(petId) {
    const apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem("CLINIC")}/files/pet/${petId}`;
    return httpGet(apiUrl);
  }
  
  addPetFilesById(petId, upload, ts = null, clinicId) {
    const formData = new FormData();
    Object.keys(upload).forEach((key) => {
      formData.append(key, upload[key]);
    });

    const clinic = clinicId ? clinicId : localStorage.getItem("CLINIC")

    const apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinic}/files/pet/${petId}${ts ? `/${ts}` : ''}`;
    return httpPost(apiUrl, formData);
  }
  
  addPetFilesByIdByPhone(petId, upload, ts = null, clinicId) {
    const formData = new FormData();
    Object.keys(upload).forEach((key) => {
      formData.append(key, upload[key]);
    });

    const clinic = clinicId ? clinicId : localStorage.getItem("CLINIC")

    const apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinic}/files/pet/${petId}${ts ? `/${ts}` : ''}`;
    return httpPost(apiUrl, formData, this.getAuthHeaders());
  }
  
  updatePetFilesByIdAndTs(petId, ts, data) {
    const apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem("CLINIC")}/files/pet/${petId}/${ts}`;
    return httpPut(apiUrl, data);
  }

  deletePetFilesByIdAndTs(petId, ts) {
    const apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem("CLINIC")}/files/pet/${petId}/${ts}`;
    return httpDelete(apiUrl);
  }
  
  deleteSinglePetFileById(petId, ts, fileId) {
    const apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem("CLINIC")}/files/pet/${petId}/${ts}/${fileId}`;
    return httpDelete(apiUrl);
  }
}
